import Delta3PortablePowerStation from '@elem/compPage/delta-3-portable-power-station';
import { IPageStatus } from '@elem/compPage/delta-3-portable-power-station/config/IPageStatus';
import { ProductProvider } from '@elem/compPage/delta-3-portable-power-station/ProductProvider';
import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { redirectTo404 } from '@/utils';
import { useLang } from '@/i18n';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';

const whiteLocaleList = ['mx'];
const isPrd = process.env.NEXT_PUBLIC_MODY === 'prd';

interface PageProps {
    SEO?: any;
    lang: {
        seo_title?: string;
        seo_desc?: string;
    };
    timeLine: any;
    pageStatus: IPageStatus;
    systemTime: number;
}

export default function Page({ SEO, lang, timeLine, pageStatus, systemTime }: PageProps) {
    const { locale = 'mx' } = useRouter();
    const { t } = useLang('delta3series');
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    const initState = {
        systemTime: systemTime,
        pageStatus: pageStatus,
        timeLine: timeLine,
        productTabActive: 'Product',
    };

    return (
        <PageLayout isNoFixed={true}>
            <SEO title={lang.seo_title || t('seo_title')} description={lang.seo_desc || t('seo_desc')} />
            <SEOlinksA locale={locale} list={whiteLocaleList} pathname="delta-3-portable-power-station" />
            <GtmPageLoad />
            <ProductProvider state={initState}>
                <Delta3PortablePowerStation />
            </ProductProvider>
        </PageLayout>
    );
}

export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
    const { debug, _timer } = query;

    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }

    let data = null;
    try {
        data = require(`elem/compPage/delta-3-portable-power-station/config/times/${locale}.js`);
    } catch (err) {
        data = require(`elem/compPage/delta-3-portable-power-station/config/times/mx.js`);
    }

    const timeLine = data.timeLine || null;
    let systemTime = new Date().getTime();
    if (_timer) {
        const _timer2 = `${_timer} GMT+8`;
        systemTime = new Date(_timer2).getTime();
    }

    let pageStatus = IPageStatus.statusA;
    if (debug) {
        pageStatus = debug as any;
    } else if (timeLine) {
        if (systemTime >= timeLine?.statusD?.start) {
            pageStatus = IPageStatus.statusD;
        } else if (systemTime >= timeLine?.statusC?.start) {
            pageStatus = IPageStatus.statusC;
        } else if (systemTime >= timeLine?.statusB?.start) {
            pageStatus = IPageStatus.statusB;
        } else if (systemTime >= timeLine?.statusA?.start) {
            pageStatus = IPageStatus.statusA;
        } else if (isPrd) {
            return redirectTo404();
        }
    }

    return {
        props: {
            systemTime,
            timeLine: timeLine,
            debug: debug || '',
            pageStatus: pageStatus,
        },
    };
}
